import axios, { AxiosResponse } from 'axios';

import { toast } from 'sonner';
import type { RequestGlobalConfig } from '@koi-design/vix-tools';
import { EmusRequestTypeMap } from '@/api/emus';
const requestConfig: Partial<RequestGlobalConfig> = {};
// const corpIdMap = {
//   localhost: 'ww026189ab05972f25',
//   yxtechai: 'ww026189ab05972f25'
// };

// Object.keys(corpIdMap).forEach(key => {
//   if (window.location.href.includes(key)) {
//     corpId = corpIdMap[key];
//   }
// });

requestConfig.API_REQUEST_CONTENT_TYPE = 'application/json'; // 通用请求类型
requestConfig.API_REQUEST_TIMEOUT = 600000; // 接口超时时间
requestConfig.API_SUCCESS_CODE = '000000'; // 接口返回成功码
requestConfig.API_EXPIRED_CODE = '100013'; // 鉴权失败码
requestConfig.EXPIRED_TO_URL = `/#/login`; // 鉴权失败跳转地址
// requestConfig.API_REQUEST_HEADERS = {
//   corpId: corpId
// };

const errMsgMap = new Map();

// axios 响应拦截器
axios.interceptors.response.use((response: AxiosResponse) => {
  // 可以在这里添加响应处理逻辑
  // 例如：处理特定错误码、记录日志等

  // 示例：处理账号在其他设备登录的情况
  const { data, config: reqConfig } = response;
  console.log(response, 'axios response');

  if (data.code !== requestConfig.API_SUCCESS_CODE) {
    try {
      if (reqConfig.url?.endsWith('getCopilotValueByTaskId')) {
        const reqConfigData = JSON.parse(reqConfig.data);
        if (reqConfigData.reqType) {
          const reqType =
            EmusRequestTypeMap[reqConfigData.reqType as keyof typeof EmusRequestTypeMap];
          const errMsg = `请求${reqType}发生错误：${data.message}，错误码：${data.traceId}，错误码已经复制到剪贴板`;
          try {
            navigator.clipboard.writeText(data.traceId);
            toast.error(errMsg, {
              id: errMsg,
              duration: 3000
            });
          } catch (error) {
            console.log(error, 'error');
          }
        }
      } else {
        const errMsg = `请求发生错误：${data.message}，错误码：${data.traceId}，错误码已经复制到剪贴板`;
        try {
          navigator.clipboard.writeText(data.traceId);
          toast.error(errMsg, {
            id: errMsg,
            duration: 3000
          });
        } catch (error) {
          console.log(error, 'error');
        }
      }
    } catch (error) {
      console.log(error, 'error');
    }
  } else {
    if (reqConfig.url?.endsWith('getCopilotValueByTaskId')) {
      const reqConfigData = JSON.parse(reqConfig.data);
      const reqType =
        EmusRequestTypeMap[reqConfigData.reqType as keyof typeof EmusRequestTypeMap] || '';
      console.log(data, errMsgMap, 'datagetCopilotValueByTaskIdgetCopilotValueByTaskId');
      if (data.data) {
        if (typeof data.data === 'object' && Object.keys(data.data).length === 0) {
          console.log(
            errMsgMap.has(`${reqConfig.url}-${reqType}`),
            'errMsgMap.has(`${reqConfig.url}-${reqType}`'
          );
          if (!errMsgMap.has(`${reqConfig.url}-${reqType}`)) {
            const errMsg = `请求${reqType}成功，但是数据为空`;
            // toast.error(errMsg, {
            //   id: errMsg
            // });
            console.log(errMsg, 'errMsg');

            errMsgMap.set(`${reqConfig.url}-${reqType}`, errMsg);
          }
        } else {
          errMsgMap.delete(`${reqConfig.url}-${reqType}`);
        }
      } else {
        const errMsg = `请求${reqType}成功，但是数据为空`;
        // toast.error(errMsg, {
        //   id: errMsg
        // });
        console.log(errMsg, 'errMsg');
      }
    }
  }
  return response;
});

export default requestConfig;
